import { BaseListenable1u3g4s45l82o6 as BaseListenable } from './abstracts.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  KtMutableList1beimitadwkna as KtMutableList,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  set3ct43wkzm94lj as set,
  valueSet3cf2hvvu95f3 as valueSet,
  lens2e2i845xidu26 as lens,
  lens26es9640ifscs as lens_0,
  get_state389x218zizu8a as get_state,
  MutableReactiveValuettf5l2qj6mxh as MutableReactiveValue,
} from './coreInterfaces.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ReactiveMutableListClass;
function ReactiveMutableList() {
  if (ReactiveMutableListClass === VOID) {
    class $ extends BaseListenable() {
      constructor(list) {
        return new.target.new_com_lightningkite_reactive_core_ReactiveMutableList_wehlhb_k$(list);
      }
      static new_com_lightningkite_reactive_core_ReactiveMutableList_wehlhb_k$(list) {
        var $this = this.new_com_lightningkite_reactive_core_BaseListenable_e3suws_k$();
        $this.list_1 = list;
        return $this;
      }
      static new_com_lightningkite_reactive_core_ReactiveMutableList_tgiub6_k$() {
        return this.new_com_lightningkite_reactive_core_ReactiveMutableList_wehlhb_k$(ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$());
      }
      set_value_ee0vzc_k$(value) {
        this.list_1.clear_j9egeb_k$();
        this.addAll_v4mac1_k$(value);
      }
      set_value_v1vabv_k$(_set____db54di) {
        return this.set_value_ee0vzc_k$((!(_set____db54di == null) ? isInterface(_set____db54di, KtList()) : false) ? _set____db54di : THROW_CCE());
      }
      get_value_j01efc_k$() {
        return this.list_1;
      }
      clear_j9egeb_k$() {
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.list_1.isEmpty_y1axqb_k$()) {
          // Inline function 'com.lightningkite.reactive.core.ReactiveMutableList.signal' call
          this.list_1.clear_j9egeb_k$();
          // Inline function 'kotlin.also' call
          this.invokeAllListeners_uusj2y_k$();
        }
      }
      removeAt_6niowx_k$(index) {
        // Inline function 'com.lightningkite.reactive.core.ReactiveMutableList.signal' call
        // Inline function 'kotlin.also' call
        var this_0 = this.list_1.removeAt_6niowx_k$(index);
        this.invokeAllListeners_uusj2y_k$();
        return this_0;
      }
      set_9t5s9l_k$(index, element) {
        // Inline function 'com.lightningkite.reactive.core.ReactiveMutableList.signal' call
        // Inline function 'kotlin.also' call
        var this_0 = this.list_1.set_82063s_k$(index, element);
        this.invokeAllListeners_uusj2y_k$();
        return this_0;
      }
      set_82063s_k$(index, element) {
        return this.set_9t5s9l_k$(index, element);
      }
      addAll_v4mac1_k$(elements) {
        // Inline function 'com.lightningkite.reactive.core.ReactiveMutableList.signalChange' call
        // Inline function 'kotlin.also' call
        var this_0 = this.list_1.addAll_4lah1e_k$(elements);
        if (this_0) {
          this.invokeAllListeners_uusj2y_k$();
        }
        return this_0;
      }
      addAll_4lah1e_k$(elements) {
        return this.addAll_v4mac1_k$(elements);
      }
      add_gaf1mg_k$(index, element) {
        // Inline function 'com.lightningkite.reactive.core.ReactiveMutableList.signal' call
        this.list_1.add_dl6gt3_k$(index, element);
        // Inline function 'kotlin.also' call
        this.invokeAllListeners_uusj2y_k$();
        return Unit_instance;
      }
      add_dl6gt3_k$(index, element) {
        return this.add_gaf1mg_k$(index, element);
      }
      add_wl2rvy_k$(element) {
        // Inline function 'com.lightningkite.reactive.core.ReactiveMutableList.signal' call
        // Inline function 'kotlin.also' call
        var this_0 = this.list_1.add_utx5q5_k$(element);
        this.invokeAllListeners_uusj2y_k$();
        return this_0;
      }
      add_utx5q5_k$(element) {
        return this.add_wl2rvy_k$(element);
      }
      remove_an8aut_k$(element) {
        // Inline function 'com.lightningkite.reactive.core.ReactiveMutableList.signalChange' call
        // Inline function 'kotlin.also' call
        var this_0 = this.list_1.remove_cedx0m_k$(element);
        if (this_0) {
          this.invokeAllListeners_uusj2y_k$();
        }
        return this_0;
      }
      remove_cedx0m_k$(element) {
        if (!true)
          return false;
        return this.remove_an8aut_k$(element);
      }
      listIterator_70e65o_k$(index) {
        return this.list_1.listIterator_70e65o_k$(index);
      }
      subList_xle3r2_k$(fromIndex, toIndex) {
        return this.list_1.subList_xle3r2_k$(fromIndex, toIndex);
      }
      isEmpty_y1axqb_k$() {
        return this.list_1.isEmpty_y1axqb_k$();
      }
      contains_ccp5tc_k$(element) {
        return this.list_1.contains_aljjnj_k$(element);
      }
      contains_aljjnj_k$(element) {
        if (!true)
          return false;
        return this.contains_ccp5tc_k$(element);
      }
      iterator_jk1svi_k$() {
        return this.list_1.iterator_jk1svi_k$();
      }
      get_c1px32_k$(index) {
        return this.list_1.get_c1px32_k$(index);
      }
      indexOf_u97212_k$(element) {
        return this.list_1.indexOf_si1fv9_k$(element);
      }
      indexOf_si1fv9_k$(element) {
        if (!true)
          return -1;
        return this.indexOf_u97212_k$(element);
      }
      get_size_woubt6_k$() {
        return this.list_1.get_size_woubt6_k$();
      }
    }
    protoOf($).set_revjhg_k$ = set;
    protoOf($).valueSet_aujvv6_k$ = valueSet;
    protoOf($).lens_drj4fu_k$ = lens;
    protoOf($).lens_u4wb4z_k$ = lens_0;
    protoOf($).get_state_wc71uu_k$ = get_state;
    initMetadataForClass($, 'ReactiveMutableList', $.new_com_lightningkite_reactive_core_ReactiveMutableList_tgiub6_k$, VOID, [KtMutableList(), MutableReactiveValue()], [1]);
    ReactiveMutableListClass = $;
  }
  return ReactiveMutableListClass;
}
//region block: exports
export {
  ReactiveMutableList as ReactiveMutableList2gg4x024enrbf,
};
//endregion

//# sourceMappingURL=ReactiveMutableList.mjs.map
